import React from 'react'
import { graphql } from 'gatsby'
import { Background, Container, Section } from '../../components/page'
import { HeroTitle } from '../../components/hero'
import { ContentfulRichText } from '../../components/contentful-rich-text'

import * as styles from './rich-text.module.scss'

export type RichTextProps = Queries.RichTextFragment

export const RichText = ({ title, text }: RichTextProps) => {
  return (
    <>
      <Section className={styles.hero} variant="hero">
        <Container>
          <HeroTitle color="light" center nomargin>
            {title}
          </HeroTitle>
        </Container>
        <Background className={styles.background} variant="ellipse" />
      </Section>
      <Section>
        <Container className={styles.content}>
          <ContentfulRichText text={text} variant="large" />
        </Container>
      </Section>
    </>
  )
}

export const RichTextFragments = graphql`
  fragment RichText on ContentfulRichText {
    __typename
    id
    title
    text {
      raw
    }
  }
`
